import { render, staticRenderFns } from "./okAddUser.vue?vue&type=template&id=8cdf8236&scoped=true"
import script from "./okAddUser.vue?vue&type=script&lang=js"
export * from "./okAddUser.vue?vue&type=script&lang=js"
import style0 from "./okAddUser.vue?vue&type=style&index=0&id=8cdf8236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdf8236",
  null
  
)

export default component.exports